import { useState, useEffect } from 'react';

let cache: any = null;

export function useContent() {
  const [content, setContent] = useState<any>(cache);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    if (cache) return;
    fetch('/content.json')
      .then(r => r.json())
      .then(data => {
        cache = data;
        setContent(data);
        setLoading(false);
      });
  }, []);

  return { content, loading };
}
